import { environment } from '@env/environment';

export const routeToMenuMapping = {
  administrationDictionaries: 'slowniki',
  administracjaSlownikiGrupyStanowisk: 'slowniki/grupy-stanowisk',
  administrationAcademicDegrees: 'slowniki/stopnie-naukowe',
  administrationAcademicTitle: 'slowniki/tytuly-naukowe',
  administrationAcademicYear: 'slowniki/lata-akademickie',
  administrationBuildings: 'slowniki/budynki',
  administrationBuildingTypes: 'slowniki/typy-budynkow',
  administrationCities: 'slowniki/miejscowosci',
  administrationCitizenships: 'slowniki/obywatelstwa',
  administrationColleges: 'slowniki/szkoly-wyzsze',
  administrationCountries: 'slowniki/kraje',
  administrationDefinableFields: 'slowniki/pola-definiowalne',
  administrationDidacticCycles: 'slowniki/cykle-dydaktyczne',
  administrationDidacticCyclesTypes: 'slowniki/typy-cykli-dydaktycznych',
  administrationDisabilityDegrees: 'slowniki/stopnie-niepelnosprawnosci',
  administrationForeignLanguages: 'slowniki/jezyki-obce',
  administrationGenders: 'slowniki/plcie',
  administrationGettingDegreeModes: 'slowniki/tryb-nadania-stopnia-naukowego',
  administrationIDs: 'slowniki/rodzaje-dokumentow-tozsamosci',
  administrationProfessionalTitle: 'slowniki/tytuly-zawodowe',
  administrationRooms: 'slowniki/sale',
  administrationRoomTypes: 'slowniki/typy-sal',
  administrationStreets: 'slowniki/ulice',
  administrationUnits: 'slowniki/jednostki',
  administrationUnitsTypes: 'slowniki/typy-jednostek',
  administracjaZrodlaFinansowania: 'slowniki/zrodla-finansowania',
  administracjaCharakteryPracy: 'slowniki/charaktery-pracy',
  administracjaRodzajeNiepelnosprawnosci: 'slowniki/rodzaje-niepelnosprawnosci',
  administrationUniversityTitle: 'slowniki/tytuly-uczelniane',
  administracjaFormyZatrudnienia: 'slowniki/formy-zatrudnienia',
  administracjaSymbolePrzyczynNiepelnosprawnosci: 'slowniki/symbole-przyczyn-niepelnosprawnosci',
  administrationFloor: 'pietra',
  administrationPeople: 'osoby',
  administrationUsers: 'uzytkownicy',
  administrationRoles: 'role',
  administrationEmployees: 'pracownicy',
  administrationUserGroups: 'grupy-uzytkownikow',
  administracjaKonfiguracjaUzytkownikow: 'konfiguracja-uzytkownikow',
  administrationSystem: 'system',
  administrationSystemAuditedOperations: 'audytowane-operacje',
  administrationSystemVersions: 'informacje-o-systemie',
  administrationSystemBasicSettings: 'ustawienia-ogolne',
  administrationSystemLoginSettings: 'ustawienia-logowan',
  administracjaDziennikPrzetwarzaniaKolejki: 'dziennik-przetwarzania-kolejki',
  administrationReports: 'raporty',
  administrationTemplates: 'szablony',
  administrationParameters: 'parametry',
  raportowanieOdmianaSlow: 'slownik-odmian',
  administrationNumerators: 'numeratory',
  administrationAzureAD: 'azure',
  administrationAzureADSettings: 'ustawienia-azure',
  administrationAzureADAudit: 'audyt-azure',
  studiaProtokolyOcen: 'protokoly-ocen',
  studiesBaseSubject: 'przedmioty-bazowe',
  studiesScientificFields: 'dziedziny-nauk',
  studiesStudyPrograms: 'programy-studiow',
  studiesSubjectsInTheCycle: 'przedmioty-w-cyklu',
  studiesFieldOfStudy: 'kierunki-studiow',
  studiesGradeValues: 'wartosci-ocen',
  studiesClassType: 'typy-zajec',
  studiesGradeTypes: 'typy-ocen',
  studiaFormaRealizacjiEgzaminuSesji: 'forma-realizacji-egzaminu-sesji',
  studiesEducationLvl: 'poziomy-ksztalcenia',
  poziomyStudiow: 'poziomy-studiow',
  studiesFormOfStudies: 'formy-studiow',
  studiesPointsTypes: 'typy-punktow',
  studiesProfiles: 'profile-studiow',
  studiesDeanGroups: 'grupy-dziekanskie',
  studiesStudents: 'studenci',
  studiesLecturers: 'wykladowcy',
  studiesHospitalizationProtocols: 'protokoly-hospitacji',
  studiesClassTerms: 'terminy-zajec',
  studiesProtocolTypes: 'typy-protokolu',
  studiesLecturerProtocols: 'protokoly',
  studiesLecturerStudyGroups: 'grupy-zajec',
  studiesLecturerOwnCoursesCalendar: 'moje-terminy-zajec',
  studiesLecturerStudyPrograms: 'programy-studiow',
  studiesLecturerErasmus: 'erasmus',
  studiesLecturerErasmusDecisions: 'erasmus/decyzje',
  studiesLecturerErasmusMobilityPlaces: 'erasmus/miejsca-mobilnosci',
  studiesLecturerErasmusWorkersMobilities: 'erasmus/mobilnosci-pracownikow',
  studiesLecturerErasmusStudentsMobilities: 'erasmus/mobilnosci-studentow',
  studiesItemCards: 'karty-przedmiotow',
  studiesSubjectsCards: 'karty-przedmiotow',
  studiesAdminMobilityPlaces: 'miejsca-mobilnosci',
  studiaPracownikNaukowyKonsultacje: 'konsultacje',
  studiesLecturerLecturers: 'wykladowcy',
  studiesItemCardsConfiguration: 'konfiguracja',
  studiesItemCardsConfigurationWorkLoad: 'obciazenia-praca',
  studiesStudentDeanGroups: 'grupy-dziekanskie',
  studiesStudentStudyGroups: 'grupy-zajeciowe',
  studiesAdminCoursesCalendar: 'terminy-zajec',
  studiesWorkersMobilities: 'mobilnosci-pracownikow',
  studiesStudentMobilities: 'mobilnosci-studentow',
  studiesStudyingBasics: 'podstawy-studiowania',
  studiesStudentMyStudyPrograms: 'programy-studiow-studenta',
  studiesStudentStudyProgram: 'programy-studiow',
  studiesStudentLecturers: 'wykladowcy',
  studiesStudentGrades: 'moje-oceny',
  studiesStudentCycleSubjects: 'przedmioty-w-cyklach',
  studiesStudentBuildingMaps: 'mapy-budynkow',
  studiesStudentSubjectToStageAssignment: 'podpiecia-przedmiotow-pod-etap',
  studiesLearningEffect: 'efekty-uczenia',
  studiesEducationStandards: 'standardy-ksztalcenia',
  studiesDirectionalEffects: 'efekty-kierunkowe',
  studiesConfiguration: 'konfiguracja',
  studiesConfigurationAverageGrades: 'srednie-ocen',
  studiesConfigurationHistoryStudyPrograms: 'historia-programow-studiow-studenta',
  studiaKonfiguracjaDataZakonczeniaStudiow: 'data-zakonczenia-studiow',
  studiaKonfiguracjaImmatrykulacja: 'immatrykulacja',
  studiaKonfiguracjaSygnatury: 'sygnatury',
  studiesConfigurationAlbumsNumbers: 'numery-albumow',
  studiesConfigurationEvaluationProtocols: 'protokoly-ocen',
  studiaKonfiguracjaTeczka: 'teczka',
  studiaKonfiguracjaKonfiguracjaSlubowania: 'konfiguracja-slubowania',
  studiesStudentCoursesCalendar: 'terminy-zajec',
  studiesStudentOwnCoursesCalendar: 'moje-terminy-zajec',
  studiesPolishQualificationFramework: 'polskie-ramy-kwalifikacji',
  studiesPolishQualificationFrameworkCategories: 'kategorie',
  studiesPolishQualificationFrameworkLevel: 'poziomy',
  studiesPolishQualificationFrameworkPoints: 'punkty',
  studiesPensum: 'pensum',
  studiesTypesOfActivity: 'typy-aktywnosci',
  studiaPowodySkreslen: 'powody-skreslen',
  studiaPowodySUrlopu: 'powody-urlopow',
  studiaWykladowcaEgzaminySesji: 'moje-egzaminy-sesji',
  studiesAdditionalActivities: 'aktywnosci-dodatkowe',
  studiaEgzaminySesji: 'egzaminy-sesji',
  studiesAdditionalActivitiesAll: 'wszystkie',
  studiaStudentEgzaminySesji: 'egzaminy-sesji',
  studiesAdditionalActivitiesSave: 'zapisane',
  studiesPensumClassesAllocation: 'przydzial-zajec',
  studiesPensumActivitiesPerformanceReports: 'sprawozdania-z-wykonania-zajec',
  studiesReports: 'raporty',
  studiesWorkingStatuses: 'statusy-robocze',
  statusyRoboczeEtapow: 'statusy-robocze-etapow',
  studiesDaysOff: 'dni-wolne',
  certificateRegister: 'rejestr-zaswiadczen',
  recruitment: 'rekrutacja',
  studiaLegitymacje: 'legitymacje',
  dyplomowanieKonfiguracja: 'konfiguracja',
  dyplomowanieKonfiguracjeProcesuDyplomowania: 'konfiguracja/konfiguracje-procesu-dyplomowania',
  dyplomowanieAlgorytmyObliczaniaOceny: 'konfiguracja/algorytmy-obliczania-ocen',
  dyplomowanieDozwoloneTypyPlikow: 'konfiguracja/dopuszczalne-rozszerzenia-plikow',
  dyplomowanieDozwoloneTypyProtokolowRecenzji: 'konfiguracja/dozwolone-typy-protokolow',
  dyplomowanieKonfiguracjaOznaczaniaPrac: 'konfiguracja/oznaczanie-prac',
  dyplomowanieMapowaniaPoziomKsztalceniaTypPracy: 'konfiguracja/mapowanie-poziom-ksztalcenia-typ-pracy',
  dyplomowanieJezyki: 'slowniki/jezyki',
  dyplomowaniePytaniaEgzaminacyjne: 'slowniki/pytania-egzaminacyjne',
  dyplomowanieTypyOcen: 'slowniki/typy-ocen',
  dyplomowanieTypyPracDyplomowych: 'slowniki/typy-prac-dyplomowych',
  dyplomowanieTypyProtokolowRecenzji: 'slowniki/typy-protokolow',
  dyplomowanieJsaKonfiguracja: 'jsa/konfiguracja',
  dyplomowanieJsaEksporty: 'jsa/eksporty',
  dyplomowanieJsaMapowaniaTypowPracDyplomowych: 'jsa/mapowania-typow-prac-dyplomowych',
  dyplomowanieJsaMapowaniaTytulowNaukowych: 'jsa/mapowania-tytulow-naukowych',
  dyplomowanieJsaTypyPracDyplomowych: 'jsa/typy-prac-dyplomowych',
  dyplomowanieJsaJezykiRaportow: 'jsa/jezyki-raportow',
  dyplomowanieJsaTypyRaportow: 'jsa/typy-raportow',
  dyplomowanieOrppdEksporty: 'orppd/eksporty',
  dyplomowanieOrppdKonfiguracjaJednostek: 'orppd/konfiguracja-jednostek',
  dyplomowanieOrppdMapowaniaTypPracyDyplomowejTytulNaukowy: 'orppd/typy-prac-dyplomowych-tytuly-naukowe',
  dyplomowanieOrppdRodzajeDokumentowTozsamosci: 'orppd/rodzaje-dokumentow-tozsamosci-orppd',
  dyplomowanieOrppdKonfiguracja: 'orppd/konfiguracja',
  dyplomowanieOrppdKraje: 'orppd/kraje',
  dyplomowanieEgzaminy: 'egzaminy',
  dyplomowanieEgzaminyLecturer: 'egzaminy',
  dyplomowanieMyExams: 'moje-egzaminy',
  dyplomowanieMyThesis: 'moje-prace-dyplomowe',
  dyplomowaniePraceDyplomowe: 'prace-dyplomowe',
  dyplomowaniePraceDyplomoweLecturer: 'prace-dyplomowe',
  dyplomowanieRaporty: 'raporty',
  dyplomowanieTasks: 'zadania',
  practicePlaces: 'miejsca-praktyk',
  practiceOffers: 'oferty-praktyk',
  practiceOffersLecturer: 'oferty-praktyk',
  practiceOffersStudent: 'oferty-praktyk',
  practiceTypesContracts: 'rodzaje-umow',
  practiceTypes: 'typy-praktyk',
  praktykiStudentow: 'praktyki-studentow',
  praktykiStudentowLecturer: 'praktyki-studentow',
  praktykiStudentowStudent: 'moje-praktyki',
  practiceProcessConfig: 'konfiguracja-procesow-praktyk',
  practiceAttachmentsTypes: 'typy-zalacznikow',
  practiceAttachmentsExtensions: 'rozszerzenia-zalacznikow',
  practiceInternshipGuards: 'opiekunowie-praktyk',
  polonCountries: 'polon-kraje',
  polonDidacticCycles: 'polon-cykle-dydaktyczne',
  polonCitizenships: 'polon-obywatelstwa',
  polonGenders: 'polon-plcie',
  polonIds: 'polon-rodzaje-dokumentow',
  polonFormsOfStudy: 'polon-formy-studiow',
  polonFieldsOfStudy: 'polon-kierunki-studiow',
  polonStudentsExports: 'polon-eksporty-studentow',
  polonUstawienia: 'polon-ustawienia',
  polonWorkers: 'polon-pracownicy',
  polonUnits: 'polon-jednostki',
  polonStudyPrograms: 'programy-studiow',
  polonMaterialSupportTypes: 'typy-pomocy-materialnej',
  polonStudyBasics: 'podstawy-studiowania',
  polonProfessionalTitles: 'tytuly-zawodowe',
  polonPracownicy: 'pracownicy',
  requestsKindsOf: 'rodzaje-podan',
  requestsStudentRequests: 'podania-studentow',
  requestsMyRequests: 'moje-podania',
  requestsCaseTypes: 'rodzaje-spraw',
  requestsStudentsCases: 'sprawy-studentow',
  requestsSettlementsTypes: 'typy-rozstrzygniec',
  requestsMyCases: 'moje-sprawy',
  requestsDecisionMakers: 'osoby-decyzyjne',
  requestsLegalJustificationsOfSubjectsDecision: 'uzasadnienia-prawne-decyzji-przedmiotowej',
  requestsLegalJustificationsOfInitRefusal: 'uzasadnienia-prawne-odmowy-wszczecia',
  requestsLegalJustificationsOfProceedingsRemission: 'uzasadnienia-prawne-umorzenia-postepowania',
  requestsDashboard: 'wnioski-dashboard',
  requestsStudentsCasesStatusVisibility: 'widocznosc-statusow-sprawy',
  requestsBenefitTypes: 'typy-dodatkowych-swiadczen',
  scholarshipsDashboard: 'stypendia-dashboard',
  scholarshipsFreshmenAchievementTypes: 'typy-osiagniec-studentow-pierwszego-roku',
  scholarshipsBestStudentsAchievementTypes: 'typy-osiagniec-najlepszych-studentow',
  scholarshipsIncomeSources: 'powody-uzyskania-dochodu',
  scholarshipsIncomeLossReasons: 'powody-utracenia-dochodu',
  scholarshipsUntaxedIncomeTypes: 'typy-dochodu-nieopodatkowanego',
  scholarshipsApplicationsConfig: 'konfiguracja-wnioskow',
  scholarshipsAidAppConfig: 'konfiguracja-wnioskow-zapomoga',
  scholarshipsBestStudentsAppConfig: 'konfiguracja-wnioskow-stypendium-rektora',
  scholarshipsFirstYearStudentsAppConfig: 'konfiguracja-wnioskow-stypendium-pierwszy-rok',
  scholarshipsSocialAppConfig: 'konfiguracja-wnioskow-socjalne',
  scholarshipsForDisabledAppConfig: 'konfiguracja-wnioskow-stypendium-dla-niepelnosprawnych',
  scholarshipsScholarshipsConfig: 'wersje-konfiguracji',
  scholarshipsMyApplications: 'moje-wnioski',
  scholarshipsApplicationsList: 'wnioski',
  scholarshipsFinishedFields: 'ukonczone-kierunki',
  scholarshipsCasesConfig: 'konfiguracja-postepowan',
  scholarshipsCasesConfigBenefit: 'konfiguracja-postepowan-zapomoga',
  scholarshipsForDisabledCasesConfig: 'konfiguracja-postepowan-dla-niepelnosprawnych',
  scholarshipsForFirstAcademicYearStudentsCasesConfig: 'konfiguracja-postepowan-rektorskie-dla-pierwszego-roku',
  scholarshipsDecisionMakers: 'osoby-decyzyjne',
  scholarshipsLegalJustificationsOfSubjectsDecision: 'uzasadnienia-prawne-decyzji-przedmiotowej',
  scholarshipsLegalJustificationsOfInitRefusal: 'uzasadnienia-prawne-odmowy-wszczecia',
  scholarshipsLegalJustificationsOfProceedingsRemission: 'uzasadnienia-prawne-umorzenia-postepowania',
  scholarshipsStudentsCases: 'postepowania-studentow',
  scholarshipsIncomeStatements: 'oswiadczenia-o-dochodach',
  downloadsForStudents: 'materialy-do-pobrania',
  scholarshipsBestStudentsRanks: 'rankingi-najlepszych-studentow',
  scholarshipsDeductionsTypes: 'rodzaje-odliczen',
  scholarshipsForBestStudentsCasesConfig: 'konfiguracja-postepowan-rektorskie-dla-najlepszych',
  scholarshipsDecisionResults: 'wyniki-decyzji-stypendialnych',
  scholarshipsDecisionResultsForDisabled: 'wyniki-decyzji-stypendialnych/2',
  scholarshipsDecisionResultsSocial: 'wyniki-decyzji-stypendialnych/3',
  scholarshipsDecisionResultsRectorsForBestStudents: 'wyniki-decyzji-stypendialnych/5',
  scholarshipsDecisionResultsRectorsForFirstAcademicYear: 'wyniki-decyzji-stypendialnych/4',
  scholarshipsDecisionResultsBenefits: 'wyniki-decyzji-stypendialnych/1',
  scholarshipsPaymentsListConfig: 'konfiguracja-listy-wyplat',
  scholarshipsPaymentsListView: 'lista-wyplat',
  scholarshipsSocialConfig: 'konfiguracja-postepowan-stypendium-socjalne',
  scholarshipsStudentStatuses: 'konfiguracja-statusow-studenta',
  scholarshipsStudentsCasesStatusVisibility: 'widocznosc-statusow-postepowania-stypendialnego',
  scholarshipsAchievementsGroups: 'grupy-osiagniec',
  scholarshipsIncomeStatementsList: 'oswiadczenia-o-dochodach',
  scholarshipsReports: 'raporty',
  scholarshipsSeriesPrintsHistory: 'historia-wydrukow',
  scholarshipsSeriesPrintsAppeals: 'wydruki-wezwan',
  scholarshipsSeriesPrintsDecisions: 'wydruki-decyzji',
  scholarshipsStudentCasesDefinitionConfig: 'konfiguracja-definicji-spraw',
  scholarshipsDisabilityCauses: 'przyczyny-niepelnosprawnosci',
  financesDiscounts: 'bonifikaty',
  financesProducts: 'produkty',
  financesInstallmentsPlan: 'plany-ratalne',
  financesStudents: 'studenci',
  financesTypesOfBankAccounts: 'typy-rachunkow-bankowych',
  financesConfiguration: 'konfiguracja',
  financesConfigurationPrice: 'cenniki',
  finanseKonfiguracjaUstawieniaOgolne: 'ustawienia-ogolne',
  finanseKonfiguracjaOdsetki: 'odsetki',
  finanseStudentOplatyIWplaty: 'oplaty-i-wplaty',
  financesReports: 'raporty',
  financesInterestNotes: 'noty-odsetkowe',
  financesTypeOfAccountingAccounts: 'rodzaje-kont-ksiegowych',
  financesConfigurationCurrency: 'waluty',
  financesImports: 'importy',
  financesConfigurationGenerator: 'generator-rachunku-bankowego',
  financesConfigurationTypesOfBankAccounts: 'typy-rachunku-bankowego',
  finanseKonfiguratorKalendarz: 'kalendarz-dni-wolnych',
  finanseKonfiguratorImporty: 'schemat-importu',
  financesCauses: 'przyczyny',
  finanseRodzajeProduktow: 'rodzaje-produktow',
  filesRepositoryAdminFilesToDownload: 'pliki-do-pobrania',
  filesRepositoryPracownikNaukowyFilesToDownload: 'pliki-do-pobrania',
  filesRepositoryStudentFilesToDownload: 'pliki-do-pobrania',
  filesRepositoryAdminFilesManagement: 'zarzadzanie-plikami',

  financesAnonim: 'nierozliczone-wplaty',
  financesWplaty: 'wplaty',
  mojeDaneDaneOsobowe: 'dane-osobowe',
  mojeDaneDaneKontaktowe: 'dane-kontaktowe',
  mojeDaneNumeryAlbumow: 'numery-albumow',
};

export const baseModulesRoutes = {
  administration: '/administracja',
  studies: '/studia',
  dissertation: '/dyplomowanie',
  practices: '/praktyki',
  requests: '/wnioski',
  scholarships: '/stypendia',
  finances: '/finanse',
  classifieds: '/ogloszenia',
  filesRepository: '/repozytorium-plikow',
  mojeDane: '/moje-dane',
  ...environment.externalModulesUrls,
};
